export default "__VITE_ASSET__W3d5Pw$5__"